/**
 * ProfessocialPost unterscheidet die Templates und stellt alle Module dafür bereit
 */

import React from 'react'

import {
  PostTypeEnum,
  ViewEnum,
  ScreenEnum, PostingTemplate,
} from '@professocial/professocialTypes/types/commonTypes'
import { FacebookPost } from '@3m5/sm_publish-frontend-api'

import FacebookOverview from './FacebookOverview'
import FacebookPreview from './FacebookPreview'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { EUserRole } from '@professocialApi/professocial-core-frontend-api'

export interface IFacebookPostProps {
  userRole?: EUserRole
  view?: ViewEnum
  postType?: PostTypeEnum
  size?: ScreenEnum
  networkPageId?: string
  post: FacebookPost | PostingTemplate | undefined
  networkType?: NetworkType
  onEditFeed?: (post: any) => void
}

const FacebookPostTemplate: React.FC<IFacebookPostProps> = (props: IFacebookPostProps) => {
  let postType: PostTypeEnum = PostTypeEnum.MESSAGE
  if (props.post?.content.image?.url) postType = PostTypeEnum.PHOTO
  if (props.post?.content.video?.url) postType = PostTypeEnum.VIDEO
  if (props.post?.content.link?.url) postType = PostTypeEnum.LINK

  const showTemplate = () => {
    switch (props.view) {
    case ViewEnum.overview:
      return (
        <FacebookOverview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          networkPageId={props.networkPageId}
          post={props.post}
          networkType={NetworkType.Facebook}
          onEditFeed={props.onEditFeed}
        />)
    case ViewEnum.preview:
      return (
        <FacebookPreview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          networkPageId={props.networkPageId}
          post={props.post}
          networkType={NetworkType.Facebook}
        />)
    }
  }

  return (
    <>
      {showTemplate()}
    </>
  )
}
export default FacebookPostTemplate
